// extracted by css-extract-rspack-plugin
export default {"segmentsLink":"k_TLY","active":"hvWFt","segmentsIcon":"lwB18"};